import type { BrandingVersionPatchInput } from "../../api/generated.ts";

const editableRoots = [
  "name",
  "metadata",
  "assets",
  "assetRoles",
  "typography",
  "defaultModeId",
  "modes",
  "runtimeSelection",
  "extensions",
] as const;

export function patchEditableRoots(
  current: Record<string, unknown>,
  next: Record<string, unknown>,
): BrandingVersionPatchInput["operations"] {
  for (const key of new Set([...Object.keys(current), ...Object.keys(next)])) {
    if (
      !editableRoots.includes(key as (typeof editableRoots)[number]) &&
      JSON.stringify(current[key]) !== JSON.stringify(next[key])
    ) {
      throw new Error(`The top-level field "${key}" is immutable in a draft patch.`);
    }
  }
  const operations: BrandingVersionPatchInput["operations"][number][] = [];
  for (const key of editableRoots) {
    const currentHas = Object.prototype.hasOwnProperty.call(current, key);
    const nextHas = Object.prototype.hasOwnProperty.call(next, key);
    if (
      currentHas &&
      nextHas &&
      JSON.stringify(current[key]) !== JSON.stringify(next[key])
    ) {
      operations.push({ op: "replace", path: `/${key}`, value: next[key] });
    } else if (!currentHas && nextHas) {
      operations.push({ op: "add", path: `/${key}`, value: next[key] });
    } else if (currentHas && !nextHas) {
      operations.push({ op: "remove", path: `/${key}` });
    }
  }
  return operations;
}
